<template>
  <div class="container">
    <div class="footerProject__container">
      <div class="footerProject__header">
        <h4 class="white">
          聯合七十 許願未來
        </h4>
        <div class="divider gold"></div>
      </div>
      <div class="footerProject__blocks">
        <div class="footerProject__block" v-for="(project, index) in projects" :key="index">
          <div class="footerProject__contentBlock">
            <div class="contentBlock">
              <h6 class="title">
                <a :href="project.url" target="_blank">{{ project.title }}</a>
                </h6>
              <h6 class="subTitle">
                <a :href="project.url" target="_blank">{{ project.subTitle }}</a>
                </h6>
            </div>
            <div class="image">
              <!-- <img :src="project.image" @click="clickendproject(project.ga)"/> -->
              <a :href="project.url" target="_blank"><img :src="project.image[selectSrc_3('mob', 'pad', 'web')]" @click="clickendproject(project.ga)"/></a>
            </div>
          </div>
          <div class="divider"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import project_Mob1 from '@/assets/img/footer/footer_1_mob.png'
import project_Mob2 from '@/assets/img/footer/footer_2_mob.png'
import project_Mob3 from '@/assets/img/footer/footer_3_mob.png'
import project_Mob4 from '@/assets/img/footer/footer_4_mob.png'
import project_Mob5 from '@/assets/img/footer/footer_5_mob.png'

// import project_Pc1 from '@/assets/img/footer/footer_1_pc.png'
import project_Pc2 from '@/assets/img/footer/footer_2_pc.png'
import project_Pc3 from '@/assets/img/footer/footer_3_pc.png'
import project_Pc4 from '@/assets/img/footer/footer_4_pc.png'
import project_Pc5 from '@/assets/img/footer/footer_5_pc.png'

  import { sendGaMethods ,selectSrcMethod_3 } from '@/assets/js/utils/masterBuilder.js';
  export default {
    mixins: [sendGaMethods,selectSrcMethod_3],
    data() {
      return {
        projects: [
          // {
          //   title: '為台灣許願',
          //   subTitle: '守護家園的70位實踐家',
          //   url: 'https://udn70.udn.com/',
          //   ga: 'ending_main_page',
          //   image: { mob: project_Mob1, pad: project_Mob1, web: project_Pc1},
          //   // image: require('@/assets/img/footer/footer_1_mob.png'),
          // },
          {
            title: '見證歷史',
            subTitle: '回顧台灣重要時刻',
            url: 'https://udn70.udn.com/story/',
            ga: 'ending_past_70',
            image: { mob: project_Mob2, pad: project_Mob2, web: project_Pc2},
            // image: require('@/assets/img/preload.png'),
          },
          {
            title: '超越報紙 迎向數位',
            subTitle: '聯合報10年轉型之路',
            url: 'https://udn70.udn.com/digital-transformation/',
            ga: 'ending_report',
            image: { mob: project_Mob3, pad: project_Mob3, web: project_Pc3},
            // image: require('@/assets/img/preload.png'),
          },
          {
            title: '文學星空下',
            subTitle: '聯合副刊70周年線上展',
            url: 'https://event.udn.com/lianfu70/',
            ga: 'ending_Lianfu',
            image: { mob: project_Mob5, pad: project_Mob5, web: project_Pc5},
            // image: require('@/assets/img/preload.png'),
          },
          {
            title: '報導+行動',
            subTitle: '願景工程促正向改變',
            url: 'https://www.vision10years.com.tw/',
            ga: 'ending_vision',
            image: { mob: project_Mob4, pad: project_Mob4, web: project_Pc4},
            // image: require('@/assets/img/preload.png'),
          },
        ]
      }
    },
    methods:{
      clickendproject(linkpara){
        this.sendGA({category: 'ending', action: 'click', label: linkpara});
      }
    }
  }
</script>

<style lang="scss" scoped>
 .container {
   background: #1D1C1B;
 }
 .footerProject__container {
   padding: 60px 16px;
   @media screen and (min-width: 768px) {
      width: 592px;
      padding: 100px 0;
      margin: 0 auto;
    }
    @media screen and (min-width: 1280px) {
      padding: 130px 0;
      width: 900.5px;
    }
 }
 .divider {
   width: 100%;
   height: 1px;
   background: rgba(139, 139, 139, 0.15);
   margin-top: 20.5px;
   @media screen and (min-width: 768px) {
      display: none;
    }
   &.gold {
    background: linear-gradient(to right, #A08E33 0%, #1D1C1B 100%);
    margin-top: 3.5px;
    @media screen and (min-width: 768px) {
      display: block;
    }
   }
 }
 .footerProject__blocks {
   width: 100%;
   display: flex;
   justify-content: space-between;
   flex-direction: column;
   @media screen and (min-width: 768px) {
      flex-direction: row;
      justify-content: flex-start;
      flex-wrap: wrap;
    }
    @media screen and (min-width: 1280px) {
      flex-wrap: unset;
    }
 }
.footerProject__block {
  padding-top: 20.5px;
  @media screen and (min-width: 768px) {
    padding-bottom: 0px;
    padding-top: 30px;
  }
  @media screen and (min-width: 1280px) {
    padding-top: 20.5px;
  }
  &:nth-child(2n) {
    @media screen and (min-width: 768px) {
      margin-left: 30px;
    }
  }
  & + & {
    @media screen and (min-width: 1280px) {
      margin-left: 10px;
    }
  }
}
 .footerProject__contentBlock {
   display: flex;
   justify-content: space-between;
   @media screen and (min-width: 768px) {
      flex-direction: column-reverse;
    }
 }
 .contentBlock {
   display: flex;
   flex-direction: column;
   justify-content: flex-start;
   @media screen and (min-width: 768px) {
     padding-top: 10px;
   }
 }
 .title, .subTitle {
   font-size: 16px;
   padding-top: 0;
   @media screen and (min-width: 768px) {
     font-size: 18px;
   }
   & > a {
     font-family: "Roboto", "Noto Serif TC", serif;
     text-decoration: none;
     color: #8B8B8B;
   }
 }
 .image {
   cursor: pointer;
   width: 110px;
   height: 82.5px;
   overflow: hidden;
    @media screen and (min-width: 414px) {
      width: 160px;
      height: 120px;
    }
    @media screen and (min-width: 768px) {
      width: 281px;
      height: 210px;
      
    }
    @media screen and (min-width: 1280px) {
      width: 217.5px;
      height: 232px;
    }
 }
 img {
   width: 100%;
   height: 100%;
   transition: all 0.5s ease-in-out;
    @media (hover: hover) {
      &:hover {
        transform: scale(1.08);
      }
    }
 }
</style>